import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMacbook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"macbook, laptop, computer"} maskId="square-filled-radius-0-stroke-1-IconMacbook"><path d="M23 21H1V18H23V21Z" fill="currentColor"/><path d="M21 17H3V3H21V17Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMacbook;
